<style lang="less">
@import "./messageManage.less";
</style>
<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <p slot="title">
            <span v-if="type == 0">发送新消息</span>
            <span v-else>编辑消息</span>
          </p>
          <Row>
            <Form
              ref="form"
              :model="form"
              :label-width="70"
              :rules="formValidate"
              style="position: relative"
            >
              <FormItem label="消息类型" prop="messageType">
                <Select
                  v-model="form.messageType"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <Option
                    v-for="(item, i) in dictMessageType"
                    :key="i"
                    :value="Number(item.dicDataValue)"
                    >{{ item.dicDataTitle }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem label="标题" prop="messageTitle">
                <Input v-model="form.messageTitle" style="width: 600px" />
              </FormItem>
              <FormItem label="摘要" prop="summary">
                <Input
                  v-model="form.summary"
                  type="textarea"
                  autocomplete="off"
                  maxlength="170"
                />
              </FormItem>
              <FormItem label="内容" prop="messageContent">
                <div ref="editor"></div>
              </FormItem>
              <Form-item label class="br">
                <Button @click="editHTML" icon="ios-create-outline"
                  >编辑HTML代码</Button
                >
                <Button @click="fullscreenModal = true" icon="md-eye"
                  >预览</Button
                >
              </Form-item>
              <!--  <FormItem label="新创建账号也推送" prop="createSend">
                            <i-switch size="large" v-model="form.createSend">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <div v-if="type==0">
                            <FormItem label="发送范围">
                                <RadioGroup v-model="form.range">
                                    <Radio :label="0">全体用户</Radio>
                                    <Radio :label="1">指定用户成员</Radio>
                                </RadioGroup>
                            </FormItem>
                            <div>
                                <FormItem label="选择用户" v-if="form.range==1">
                                    <user-choose buttonText="选择发送用户" @on-change="handleSelectUser" ref="user"></user-choose>
                                </FormItem>
                            </div>
                        </div>-->
              <Form-item class="br">
                <Button
                  type="primary"
                  :loading="submitLoading"
                  @click="handelSubmit"
                  style="width: 100px"
                  >提交</Button
                >
                <Button @click="handelCancel">取消</Button>
              </Form-item>
              <Spin size="large" fix v-if="loading"></Spin>
            </Form>
          </Row>
        </Card>
      </Col>
    </Row>
    <!-- html编辑 -->
    <Modal
      title="编辑html代码"
      v-model="showHTMLModal"
      :mask-closable="false"
      :width="900"
      :fullscreen="full"
    >
      <Input
        v-if="!full"
        v-model="dataEdit"
        :autosize="true"
        type="textarea"
        style="max-height: 60vh; overflow: auto"
      />
      <Input v-if="full" v-model="dataEdit" :autosize="true" type="textarea" />
      <div slot="footer">
        <Button @click="full = !full" icon="md-expand">全屏开/关</Button>
        <Button
          @click="editHTMLOk"
          type="primary"
          icon="md-checkmark-circle-outline"
          >确定保存</Button
        >
      </div>
    </Modal>
    <Modal title="预览" v-model="fullscreenModal" fullscreen>
      <div v-html="form.messageContent">{{ form.messageContent }}</div>
      <div slot="footer">
        <Button @click="fullscreenModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  addMessage,
  editMessage,
  getDictDataByType,
  getMessageDataById,
  uploadFile,
} from "@/api/index";
import userChoose from "../../my-components/flyme/user-choose";
import E from "wangeditor";
// 表情包配置 自定义表情可在该js文件中统一修改
import { sina } from "@/libs/emoji";

let editor = null;
var xss = require("xss");
export default {
  name: "add_edit_message",
  components: {
    userChoose,
  },
  data() {
    return {
      type: 0,
      loading: false, // 表单加载状态
      selectUsers: [],
      userModalVisible: false,
      modalTitle: "", // 添加或编辑标题
      form: {
        // 添加或编辑表单对象初始化数据
        messageTitle: "",
        messageContent: "",
        messageType: 0,
        summary: "",
        range: 0,
      },
      formValidate: {
        // 表单验证规则
        messageTitle: [
          { required: true, message: "标题不能为空", trigger: "blur" },
        ],
        messageContent: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
      submitLoading: false, // 添加或编辑提交状态
      dictMessageType: [],
      dictSex: [],
      dataEdit: "", // 编辑数据
      showHTMLModal: false, // 显示html
      full: false, // html全屏开关
      fullscreenModal: false, // 显示全屏预览
      backRoute: "",
    };
  },
  methods: {
    init() {
      this.getDictDataType();
      this.initEditor();
      this.type = this.$route.query.type;
      this.backRoute = this.$route.query.backRoute;
      if (this.type == 1) {
        this.form.id = this.$route.query.id;
        this.getData();
      }
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        // this.form.messageContent = xss(html);
        this.form.messageContent = html;
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.messageContent;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.messageContent = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    getDictDataType() {
      getDictDataByType("messageType").then((res) => {
        if (res.status) {
          this.dictMessageType = res.data;
        }
      });
    },
    getData() {
      this.loading = true;
      getMessageDataById(this.form.id).then((res) => {
        this.loading = false;
        if (res.status === true) {
          // 转换null为""
          let v = res.data;
          for (let attr in v) {
            if (v[attr] === null) {
              v[attr] = "";
            }
          }
          let str = JSON.stringify(v);
          let data = JSON.parse(str);
          editor.txt.html(data.messageContent);
          this.form = data;
        }
      });
    },
    handelSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          if (this.type == 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // 用户id数据
            let ids = [];
            this.selectUsers.forEach((e) => {
              ids.push(e.id);
            });
            this.form.userIds = ids;

            addMessage(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.closeCurrentPage();
              }
            });
          } else if (this.type == 1) {
            // 编辑
            editMessage(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.closeCurrentPage();
              }
            });
          }
        }
      });
    },
    handleSelectUser(v) {
      this.selectUsers = v;
    },
    handelCancel() {
      this.closeCurrentPage();
    },
    // 关闭当前页面
    closeCurrentPage() {
      this.$store.commit("removeTag", "add_edit_message");
      localStorage.pageOpenedList = JSON.stringify(
        this.$store.state.app.pageOpenedList
      );
      this.$router.push({
        name: this.backRoute,
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      if (to.name == "add_edit_message") {
        this.type = this.$route.query.type;
        if (this.type == 1) {
          this.form.id = this.$route.query.id;
          this.getData();
        } else {
          editor.txt.html("");
        }
      }
    },
  },
};
</script>